package org.vreo.devicehub.features.roi.presentation

import androidx.compose.ui.graphics.ImageBitmap

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.roi.Roi

/**
 * Roi view state
 */
data class RoiState(
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isDeviceActive: Boolean = false,

    val image: ImageBitmap? = null,

    val selectedRoi: Roi? = null,
    val showRoiEditor: Boolean = false,
    val roi: List<Roi> = emptyList()
)